import { ChipsContainer } from 'app/ComponentLibrary/Filter/ChipsContainer';
import React, { createRef } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { selectFilters } from 'app/components/Common/Grid/GridStateManagement/GridState.selectors';
import { determineChipSelected } from 'app/components/AmWorkDesk/PlacementsDesk/filterHelper';
import { generateChips } from 'app/components/GlobalSearch/helper';

export const PassportCredSearchChips = props => {
  const { category } = props;
  const [chips, setChips] = useState({});
  const hiddenSubmitButton = createRef<HTMLButtonElement>();
  const { setValue, getValues } = useFormContext();
  const { t } = useTranslation();
  const filterObject = useSelector(selectFilters);
  const [deleteMultipleChips, setDeleteMultipleChips] = React.useState<boolean>(false);

  const getNewSelection = (key, chip) => ({
    ...filterObject?.selectedChipFilters,
    [key]: determineChipSelected(
      chip,
      filterObject?.selectedChipFilters ? filterObject?.selectedChipFilters[key] : undefined,
    ),
  });

  const handleChipDelete = (key, chip) => {
    const fieldValues = getValues(key);
    let newFieldValues: any = null;

    /**Check to avoid click on deletion of valued fields/chips */
    newFieldValues = Array.isArray(fieldValues) ? fieldValues.filter(item => item.value !== chip.value.value) : null;

    setValue(key, newFieldValues, { shouldDirty: true });
    if (chip.isSelected || props.disableFormSubmit) {
      const newSelections = getNewSelection(key, chip);
      props.onApplyFilter(
        { ...getValues(), [key]: Array.isArray(fieldValues) ? [...(newFieldValues || [])] : null },
        newSelections,
      );
    } else hiddenSubmitButton.current?.click();
  };

  /** Restricted to call onApplyfilter directly -
   * observes not to remove existing filter and chips */
  const handleChipClick = (key, chip) => {
    /**Check to avoid click on single valued fields/chips */
    if (!Array.isArray(getValues(key))) return;
    /**
     * Below functionalty are limited to type ISelection
     * Need to be updated for dates and single selection
     */
    const newSelections = getNewSelection(key, chip);
    setChips(generateChips({ ...getValues() }, t, category, false, newSelections));
    props.onApplyFilter(getValues(), newSelections);
  };

  useEffect(() => {
    setChips(
      filterObject?.filters
        ? generateChips(filterObject?.filters, t, category, false, filterObject?.selectedChipFilters)
        : {},
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterObject?.filters]);

  useEffect(() => {
    if (deleteMultipleChips) {
      const chip = { label: filterObject?.filters.radius, enabledelete: true, value: filterObject?.filters.radius };
      handleChipDelete('radius', chip);
      setDeleteMultipleChips(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteMultipleChips]);

  return (
    <>
      <ChipsContainer
        chips={chips}
        onDelete={(field, chip, index) => handleChipDelete(field, chip)}
        onClick={(field, chip, index) => handleChipClick(field, chip)}
      />
      <button ref={hiddenSubmitButton} style={{ display: 'none' }} type="submit" />
    </>
  );
};
